import Link from "next/link";

const styles = new Proxy({"ResutlsFor":"ResutlsFor-89b3b","ClearButton":"ClearButton-89b3b"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { PropsWithChildren } from "react";

const ResultsFor = ({ children }: PropsWithChildren) => (
  <h1 className={styles.ResutlsFor}>
    Results for: &quot;<span>{children}</span>&quot;
    <Link href="/blog" className="btn btn-lg mx-2 my-0 p-0">
      <i className="fa fa-times-circle fa-inverse" />
    </Link>
  </h1>
);

export default ResultsFor;
